// extracted by mini-css-extract-plugin
export default {"root":"SwiperCarousel_root__y6rmU"};